var map = {
	"./awe.json": 4529,
	"./bluebird.json": 8905,
	"./graphictees.json": 97,
	"./grass_is_green.json": 5181,
	"./kuhn.json": 5368,
	"./mysteryfish.json": 6685,
	"./readme.json": 2208,
	"./topia.json": 383
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 799;